// extracted by mini-css-extract-plugin
export var errorIcon = "_qy-1";
export var nameLogo = "_qy-0";